// v1: Kosovo cities. Add Albania / North Macedonia entries here when you expand.
const cities = [
  "Prishtinë",
  "Prizren",
  "Pejë",
  "Gjakovë",
  "Gjilan",
  "Mitrovicë",
  "Ferizaj",
  "Vushtrri",
  "Podujevë",
  "Suharekë",
  "Rahovec",
  "Lipjan",
  "Malishevë",
  "Drenas",
  "Skenderaj",
  "Klinë",
  "Istog",
  "Deçan",
  "Fushë Kosovë",
  "Obiliq",
  "Viti",
  "Kamenicë",
  "Kaçanik",
  "Shtime",
  "Dragash",
];

export default cities;
